export const getters = {
  frontMenuProductDynamicDataList: (state) => state.frontMenuProductDynamicDataList,
};
